export default "__VITE_ASSET__B__YoImm__"